import { Component, OnInit, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { NgModel, ControlContainer, NgForm } from '@angular/forms';
import { TreeNode } from 'primeng/api';

// Models
import { StudyViewModel } from '../../viewmodel/study.viewmodel';

// Services
import { TreeViewService } from '../../services/treeview.service';

// Constants
import { RegularExpressionPattern } from '../../shared/_constants';
import * as Constants from '@shared/_constants';
import { ConfigService } from '../../services/config.service';
import { Industry } from '@models/industry.model';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { AppState } from '../../reducers';
import { Store, select } from '@ngrx/store';
import { Subject, forkJoin } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { selectStudyData } from '../study.selectors';
import { LookupService } from '@services/lookup.service';
import { Study } from '../../models/study.model';
import { StudyService } from '@services/study.service';
import { GraphService } from '@services/graph.service';
import { User as Graph_User } from '@microsoft/microsoft-graph-types';
import { UserService } from '@services/user.service';
import * as StudyConstants from '../_study_constants';
import { ActivatedRoute, Router } from '@angular/router';
import { StudyDetailService } from '@services/study-detail.service';
import { StudyViewModelFactory } from '../../viewmodel/study.viewmodelfactory';
import { StudyBlockUiService } from '../../shared/study-block-ui/study-block-ui.service';
import { ConfirmationResult, ChangeType, ConfirmationMessage, ResultMessage, LocalStorage } from '@shared/_constants';
import { DialogService } from '@services/dialog.service';
import { ChangeNotificationsService } from '../change-notifications.service';
import { SearchFilterService } from '../add-filter-dialog/shared/search-filter.service';
import { updateStudy } from '../study.actions';
import { LoggingService } from '@services/logging.service';
import _ from 'lodash-es';
import { selectSearchStrategyDatabaseIds } from '../analysis/search-strategy/state/study-search-strategy.selectors';

@Component({
  selector: 'app-testedpartyinfo',
  templateUrl: './testedPartyInfo.component.html',
  styleUrls: ['./testedPartyInfo.component.css'],
})
export class TestedPartyInfoComponent implements OnInit, OnDestroy {
  @Input() studyVM: StudyViewModel = new StudyViewModel();

  @Input() submitted = false;
  submitClicked = false;
  @Input() isNewStudyIndustryBlank = false;
  selectedIndustry: Industry;
  studyIndustries: Industry[] | undefined;
  filteredIndustries: Industry[] | undefined;
  regularExpressionPattern = RegularExpressionPattern;
  showValidationMessage = false;

  // Load all Region and Country
  selectedTestedPartyCountryNodes: TreeNode[] = [];
  testedPartyBusinessDescriptionMinLength = 0;

  @Input() readOnly: boolean;
  @Input() tabIndex: number;
  @Output() lockChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() enabledCache: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() skipChangeNotifications: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() studyInfoChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  private destroy$ = new Subject();
  isSearchStudy: boolean;
  currentUser: Graph_User;
  analysisIndex = 0;
  index = 0;
  studyStatusFromDbSubscription: any;
  statusIdFromDb?: number;
  isTestedPartyInfoEditable = false;
  testedPartyInfoSubmitClicked = false;
  unChangedEditStudy: StudyViewModel = new StudyViewModel();
  selectedDatabaseIds: number[] = [];
  isNonBvdSelected = false;
  testedPartyInfoErrorMessage = '';
  saveDisabled = true;
  initialLoad = false;
  constructor(
    private treeviewService: TreeViewService,
    private configService: ConfigService,
    private studyBlockUiService: StudyBlockUiService,
    private dialogService: DialogService,
    private viewModelFactory: StudyViewModelFactory,
    private lookupService: LookupService,
    private store: Store<AppState>,
    private studyService: StudyService,
    private graphService: GraphService,
    private userService: UserService,
    private router: Router,
    public studyDetailService: StudyDetailService,
    private route: ActivatedRoute,
    private changeNotificationsService: ChangeNotificationsService,
    private searchFilterService: SearchFilterService,
    private logger: LoggingService,
  ) {
    this.configService.getConfigValue(ConfigService.TESTED_PARTY_BUSINEDD_DESCRIPTION_MIN_LENGTH).subscribe((value) => {
      if (value) this.testedPartyBusinessDescriptionMinLength = +value;
    });
  }
  ngOnChanges() {
    if (this.studyVM.study.industryId === this.studyVM.otherIndustryId) {
      this.showValidationMessage = true;
      this.studyVM.study.industryId = 0;
    }
    if (this.studyVM.industries.length > 0) {
      this.studyIndustries = this.studyVM.industries.filter((x) => x.industryId != this.studyVM.otherIndustryId);
      this.selectedIndustry = this.studyIndustries.find((x) => x.industryId == this.studyVM.study.industryId);
    }
    if (this.isNewStudyIndustryBlank) {
      this.showValidationMessage = true;
    }
  }
  ngOnInit() {
    this.initialLoad = true;
    this.studyBlockUiService.blockUI();
    this.store
      .pipe(takeUntil(this.destroy$))
      .pipe(select(selectStudyData))
      .subscribe(async (study) => {
        const fullApplicationAccess = await this.lookupService.HasFullAccessForUserLicensingCountry();

        this.initStudyViewModel(study);
        this.intiStudyDetailService(study);

        this.isSearchStudy = this.studyService.isSearchStudy;

        this.route.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
          if (typeof params['tabId'] !== undefined && params['tabId']) {
            const tabId = +params['tabId'];
            // check if querystring id is equal to analysis tabid or not
            if (tabId === StudyConstants.AnalysisTabId) {
              this.index = +params['tabId'];
            }
          }
          if (typeof params['analysisTabId'] !== undefined && params['analysisTabId']) {
            this.analysisIndex = +params['analysisTabId'];
          }
        });
        // determine if current user is study member
        this.studyVM.study.isStudyEditableByUser = false;
        this.studyVM.study.isStudyReadOnly = false;
        this.currentUser = await this.graphService.getCurrentUser();
        this.studyVM.study.hasLockAccess = this.userService.ensuredUser.isSuperUser;
        // if user is study member, study is available for user
        this.studyVM.study.isStudyEditableByUser =
          this.userService.ensuredUser.isSuperUser ||
          this.studyVM.study.userStudies.filter(
            (userstudy) =>
              // check whether user exist in User table or not
              userstudy.user.activeDirectoryId === this.currentUser.id &&
              userstudy.user.isActive === true &&
              // check whether user is active in userstudy table.
              userstudy.isActive === true,
          ).length > 0;

        // if user does not have full country access then mark it as readonly for study
        if (this.userService.ensuredUser.isSuperUser) {
          this.studyVM.study.isStudyEditableByUser = true;
        } else {
          this.studyVM.study.isStudyEditableByUser = !fullApplicationAccess ? false : this.studyVM.study.isStudyEditableByUser;
        }

        if (this.studyVM.study.isStudyEditableByUser === false) {
          // current user is not a study member, make study read-only
          this.readOnly = true;
          this.studyVM.study.isStudyReadOnly = true;
        }

        const _study = this.studyVM;
        this.viewModelFactory.initializeViewModelForEdit(_study).then((a) => {
          this.studyVM = a;

          this.studyVM.study.iqrValues.forEach((element) => {
            if (this.studyVM.selectedRatios.find((z) => z === element.ratioId) === undefined) {
              this.studyVM.selectedRatios.push(element.ratioId);
            }
          });

          if (this.studyVM.study.startDate) {
            this.studyVM.study.displayStartDate = new Date(this.studyVM.study.startDate.toString());
          }

          if (this.studyVM.study.endDate) {
            this.studyVM.study.displayEndDate = new Date(this.studyVM.study.endDate.toString());
          }

          if (this.studyVM.study.testedPartyFiscalYearEnd) {
            this.studyVM.study.displaytestedPartyFiscalYearEnd = new Date(this.studyVM.study.testedPartyFiscalYearEnd.toString());
          }

          if (this.studyVM.study.industryId === this.studyVM.otherIndustryId) {
            this.showValidationMessage = true;
            this.studyVM.study.industryId = 0;
          }
          if (this.studyVM.industries.length > 0) {
            this.studyIndustries = this.studyVM.industries.filter((x) => x.industryId != this.studyVM.otherIndustryId);
            this.selectedIndustry = this.studyIndustries.find((x) => x.industryId == this.studyVM.study.industryId);
          }
          if (this.isNewStudyIndustryBlank) {
            this.showValidationMessage = true;
          }

          this.unChangedEditStudy = _.cloneDeep(a);

          if (this.initialLoad) {
            this.studyBlockUiService.unblockUI();
          }
          this.initialLoad = false;
          
          this.saveDisabled = true;
        });
      });

    this.store
      .pipe(takeUntil(this.destroy$))
      .pipe(select(selectSearchStrategyDatabaseIds))
      .subscribe((ids) => {
        this.selectedDatabaseIds = ids;
      });
    this.loadInitialData();

    this.treeviewService.checkNode(
      this.studyVM.testedpartyregionCountries_multi,
      this.studyVM.selectedTestedPartyCountries,
      this.selectedTestedPartyCountryNodes,
    );
  }
  checkNewStudyValidation() {
    this.showValidationMessage = this.isNewStudyIndustryBlank;
  }
  ShowValidationMessage(item: NgModel): boolean {
    return (item.errors || false) && (this.submitClicked || !item.pristine || item.touched);
  }

  nodeSelect(event) {
    this.treeviewService.addNode(event.node, this.studyVM.selectedTestedPartyCountries);
    this.selectedTestedPartyCountryNodes = [];
    this.treeviewService.checkNode(
      this.studyVM.testedpartyregionCountries_multi,
      this.studyVM.selectedTestedPartyCountries,
      this.selectedTestedPartyCountryNodes,
    );
  }

  nodeUnselect(event) {
    this.treeviewService.removeNode(event.node, this.studyVM.selectedTestedPartyCountries);
    this.selectedTestedPartyCountryNodes = [];
    this.treeviewService.checkNode(
      this.studyVM.testedpartyregionCountries_multi,
      this.studyVM.selectedTestedPartyCountries,
      this.selectedTestedPartyCountryNodes,
    );
  }

  filterIndustries(event: AutoCompleteCompleteEvent) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.studyIndustries as Industry[]).length; i++) {
      let industry = (this.studyIndustries as Industry[])[i];
      if (industry.industryName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(industry);
      }
    }

    this.filteredIndustries = filtered;
  }
  IndustrySelected(event: Industry) {
    this.selectedIndustry = event;
    this.showValidationMessage = false;
    this.studyVM.study.testedPartyIndustry = this.selectedIndustry;
    this.studyVM.study.industryId = this.selectedIndustry.industryId;
    this.enableSaveButton();
  }
  clearTextbox() {
    this.showValidationMessage = true;
    this.selectedIndustry = undefined;
    this.studyVM.study.industryId = 0;
  }

  private initStudyViewModel(study: Study) {
    const iqrValues = study.iqrValues.filter(function (element) {
      return element.isActive === true;
    });
    // study.iqrValues = iqrValues
    this.studyVM.study = { ...study, iqrValues: iqrValues };
    this.studyVM.study.iqrValues.forEach((element) => {
      this.studyVM.selectedRatios.push(element.ratioId);
    });
    this.studyVM.study.searchStrategies = study.searchStrategies;
  }

  private intiStudyDetailService(study: Study) {
    this.studyDetailService.study = study;
  }

  public async saveTestedParty(form: NgForm) {
    this.submitClicked = true;
    this.logger.info(this.constructor.name, 'saveTestedParty', 'Start');
    this.testedPartyInfoSubmitClicked = true;
    if (form.valid && !!this.studyVM.study.industryId) {
      let confirmationMessage: string = ConfirmationMessage.AffectOtherAspects;
      if (this.studyPredictionEngineFieldsChanged()) {
        confirmationMessage += '<BR><BR>' + ConfirmationMessage.AffectOtherAspectsPredictionEngineReset;
      }

      // Confirmation message to display before saving data
      const confirmationResult = await this.dialogService.confirm('Please Confirm', confirmationMessage, 'Save Changes', 'Cancel');
      if (confirmationResult === ConfirmationResult.yes) {
        try {
          this.studyBlockUiService.blockUI();
          // convert list into array, to set tested party info for study model
          this.studyVM.study.testedPartyCountries = [];
          this.studyVM.selectedTestedPartyCountries.forEach((element) => {
            this.studyVM.study.testedPartyCountries.push({ regionCountryId: parseInt(element, 10) });
          });

          this.studyVM.study.industryOther = null; //as part of feature 958498 set this to null to all other studies created with industry other.
          const savedStudy = await this.studyService.UpdateTestedParty(this.studyVM.study);

          if (savedStudy) {
            this.isTestedPartyInfoEditable = false;
            this.testedPartyInfoSubmitClicked = false;

            if (
              this.unChangedEditStudy.study.functionId !== savedStudy.functionId ||
              this.unChangedEditStudy.study.businessDescription !== savedStudy.businessDescription
            ) {
              this.studyInfoChange.emit(true);
            }

            this.updateChangeNotification(this.constructor.name, false, ChangeType.TestedParty);
            this.updateChangeNotification(this.constructor.name, false, Constants.WarningMessage.TestedPartyChanged);
            this.updateStudyViewModel(savedStudy);

            this.dispatchStudyUpdateAction(savedStudy);
            // disable cache for subsequent tabs,
            this.enabledCache.emit(false);
          } else {
            this.testedPartyInfoErrorMessage = ResultMessage.ErrorEncountered;
          }
        } finally {
          this.studyBlockUiService.unblockUI();
          this.saveDisabled = true;
          this.submitClicked = false;
        }
      }
    }
  }

  private studyPredictionEngineFieldsChanged(): boolean {
    this.loadInitialData();
    return (
      (this.unChangedEditStudy.study.translateNativeLanguageTD !== this.studyVM.study.translateNativeLanguageTD && !this.isNonBvdSelected) ||
      this.unChangedEditStudy.study.functionId !== this.studyVM.study.functionId ||
      this.unChangedEditStudy.study.businessDescription !== this.studyVM.study.businessDescription ||
      JSON.stringify(this.unChangedEditStudy.selectedBenchmarkCountries) !== JSON.stringify(this.studyVM.selectedBenchmarkCountries)
    );
  }

  loadInitialData() {
    const isNonBvdDatabase$ = this.lookupService.isNonBvdDatabase(this.selectedDatabaseIds);

    forkJoin([isNonBvdDatabase$])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([_isNonBvdSelected]) => {
        this.isNonBvdSelected = _isNonBvdSelected;
      });
  }

  private updateChangeNotification(key: string, flag: boolean, msg: string) {
    this.changeNotificationsService.addNotification({ changeKey: key + '-' + msg, hasChanges: flag, warningMessage: msg });
  }

  private updateStudyViewModel(savedStudy: Study) {
    this.logger.info(this.constructor.name, 'updateStudyViewModel', 'Start');
    this.studyVM.study = savedStudy;

    // Refresh data in copy of data
    this.unChangedEditStudy = new StudyViewModel();
    this.unChangedEditStudy = _.cloneDeep(this.studyVM);

    if (this.studyVM.study.startDate) {
      this.studyVM.study.displayStartDate = new Date(this.studyVM.study.startDate.toString());
    }

    if (this.studyVM.study.endDate) {
      this.studyVM.study.displayEndDate = new Date(this.studyVM.study.endDate.toString());
    }

    if (this.studyVM.study.testedPartyFiscalYearEnd) {
      this.studyVM.study.displaytestedPartyFiscalYearEnd = new Date(this.studyVM.study.testedPartyFiscalYearEnd.toString());
    }
  }
  dispatchStudyUpdateAction(savedStudy) {
    if (savedStudy.searchStrategies[0]) {
      this.searchFilterService.generateFilterCriteriaForSearchFilters(savedStudy.searchStrategies[0].searchFilters);
    }

    this.store.dispatch(updateStudy({ study: savedStudy }));
  }

  enableSaveButton() {
    if (
      this.unChangedEditStudy.study.testedPartyName !== this.studyVM.study.testedPartyName ||
      this.unChangedEditStudy.study.functionId !== this.studyVM.study.functionId ||
      this.unChangedEditStudy.study.industryId !== this.studyVM.study.industryId ||
      this.unChangedEditStudy.study.businessDescription !== this.studyVM.study.businessDescription ||
      this.unChangedEditStudy.study.nonComparableCriteria !== this.studyVM.study.nonComparableCriteria
    ) {
      this.saveDisabled = false;
      this.updateChangeNotification(this.constructor.name, true, Constants.WarningMessage.TestedPartyChanged);
    } else {
      this.saveDisabled = true;
      this.updateChangeNotification(this.constructor.name, false, Constants.WarningMessage.TestedPartyChanged);
    }
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }
}
